module.exports = __webpack_public_path__ + "static/media/yampi1.7d455fad.png";